import { motion } from "framer-motion";
import { STEPS } from "@/lib/constants";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-white py-16 sm:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16 sm:mb-20">
          <div className="max-w-2xl">
            <p className="overline mb-5">
              <span className="inline-block w-10 h-px bg-[#D4AF37] align-middle mr-4" />
              Sådan kommer du i gang
            </p>
            <h2
              className="font-serif text-[2.25rem] sm:text-5xl lg:text-6xl text-[#111111] font-light tracking-tight leading-[1.05]"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              Fire trin - fra første samtale til{" "}
              <span className="italic text-[#C9A227]">fuld drift</span>.
            </h2>
          </div>
          <p className="max-w-md text-base sm:text-lg text-[#555555] font-light leading-relaxed">
            En enkel, gennemsigtig proces.{" "}
            <strong className="text-[#111111] font-medium">0 kr. i opstart</strong> - du
            betaler først, når din bolig tjener penge.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-black/10">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: "easeOut" }}
              className="relative bg-white p-8 sm:p-12 group hover:bg-[#F8F8F8] transition-colors duration-500"
              data-testid={`step-${s.n}`}
            >
              <div className="flex items-start justify-between gap-4 sm:gap-6 mb-5 sm:mb-6">
                <span
                  className="font-serif text-5xl sm:text-7xl text-[#D4AF37] font-light leading-none"
                  style={{ fontFamily: "Fraunces, serif" }}
                >
                  {s.n}
                </span>
                <span className="text-[9px] sm:text-[10px] tracking-[0.2em] sm:tracking-[0.3em] uppercase text-[#C9A227] mt-2 sm:mt-3 text-right max-w-[140px] sm:max-w-[200px] leading-relaxed">
                  {s.tag}
                </span>
              </div>
              <div className="h-px w-12 sm:w-16 bg-[#111111]/15 mb-5 sm:mb-6 group-hover:w-20 sm:group-hover:w-24 group-hover:bg-[#D4AF37] transition-all duration-500" />
              <h3
                className="font-serif text-xl sm:text-3xl text-[#111111] mb-3 sm:mb-4 leading-snug font-normal"
                style={{ fontFamily: "Fraunces, serif" }}
              >
                {s.title}
              </h3>
              <p className="text-[#555555] font-light leading-relaxed text-sm sm:text-base">
                {s.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
